import * as yup from 'yup'

export default yup.object().shape({
  total_bedrooms: yup
    .number()
    .required('O campo N.º de Dormitórios é requerido.'),
  description: yup.string().required('O campo Descrição é requerido.'),
  characteristics: yup
    .array()
    .required('O campo Características da Unidade é requerido.'),
  file_size: yup.number(),
  file_type: yup.string(),
  // opcionais: unidade sem códigos UAU chega na edição com null (UnitConverter),
  // e sem .nullable() o yup recusava e o "Próximo" não fazia nada
  uau_produto_code: yup.string().optional().nullable(),
  uau_personalizacao_code: yup.string().optional().nullable()
})
